import { render, staticRenderFns } from "./AssignPart.vue?vue&type=template&id=9dd11df8&"
import script from "./AssignPart.vue?vue&type=script&lang=js&"
export * from "./AssignPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports